import ProgressFlashcardComponent from '@views/progress/questions/show';

export default [
  {
    path: '/simulations',
    name: 'testSimulations#index',
    component: () => import('@views/testSimulations/index'),
    meta: {
      header: true,
    },
  },
  {
    path: '/simulations/:categoryId/start',
    name: 'testSimulations#start',
    component: () => import('@views/testSimulations/start'),
  },
  {
    path: '/simulations/:categoryId/results',
    name: 'testSimulations#results',
    component: () => import('@views/testSimulations/results'),
    meta: {
      header: true,
    },
  },
  {
    path: '/simulations/:categoryId/results/questions',
    component: () => import('@views/testSimulations/questions'),
    name: 'testSimulations#results#questions',
    meta: {
      header: true,
    },
  },
  {
    path: '/simulations/:categoryId/results/questions/:flashcardId',
    component: ProgressFlashcardComponent,
    name: 'testSimulations#results#question',
    meta: {
      header: true,
      masteryFooter: true,
    },
  },
  {
    path: '/simulations/:categoryId/congratulations',
    name: 'testSimulations#congratulations',
    component: () => import('@views/testSimulations/congratulations'),
  },
];
